"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _fieldFrame = _interopRequireDefault(require("@ux/field-frame"));
var _select = _interopRequireDefault(require("@ux/select"));
var _label = require("@ux/label");
var _text = _interopRequireDefault(require("@ux/text"));
const _excluded = ["children", "className", "label", "helpMessage", "errorMessage", "visualSize"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const UX_SELECT_INPUT_CLASSNAME = 'ux-select-input';
const UX_SELECT_INPUT_LABEL_FLOAT = false;

/**
 * Select input functional component
 * @param {Object} props - Information for the props can be found in the PropTypes below and in TextEntry propTypes
 * @param {String|React.Element} [props.label] - Label for the component
 * @param {String} [props.helpMessage] - Message for the component
 * @param {String} [props.errorMessage] - Error message for the component
 * @param {('sm' | 'md')} [props.visualSize] - Sets component size, defaults to 'md'
 * @param {Object} ref - Forwarded ref to TextEntry
 * @returns {React.Component} SelectInput component
 */
const SelectInput = /*#__PURE__*/_react.default.forwardRef(function selectInput(_ref, ref) {
  let {
      children,
      className,
      label,
      helpMessage,
      errorMessage,
      visualSize = 'md'
    } = _ref,
    selectProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    id,
    invalid,
    disabled,
    required,
    labelExperimentalFloat
  } = selectProps || {};
  const helpMessageId = helpMessage && `${id}-help`;
  const errorMessageId = errorMessage && `${id}-error`;

  // Determine if the label should float. Small components don't support floating labels.
  const float = visualSize !== 'sm' && labelExperimentalFloat || UX_SELECT_INPUT_LABEL_FLOAT;
  const classNames = (0, _classnames.default)(`${UX_SELECT_INPUT_CLASSNAME}-shell`, `${UX_SELECT_INPUT_CLASSNAME}--size-${visualSize}`, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classNames,
    "data-version": "2400"
  }, !float && (0, _label.ensureLabelComponent)(label, {
    htmlFor: id,
    required
  }), /*#__PURE__*/_react.default.createElement(_fieldFrame.default, {
    disabled,
    invalid
  }, /*#__PURE__*/_react.default.createElement(_select.default, (0, _extends2.default)({
    "aria-invalid": invalid,
    "aria-describedby": helpMessageId,
    "aria-errormessage": errorMessageId,
    label: float && label,
    stretch: true,
    visualSize: visualSize,
    ref: ref
  }, selectProps), children)), helpMessage && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    text: helpMessage,
    as: "caption",
    id: helpMessageId,
    emphasis: "passive"
  }), errorMessage && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    text: errorMessage,
    as: "caption",
    id: errorMessageId,
    emphasis: "critical",
    role: "alert"
  }));
});
SelectInput.propTypes = _objectSpread(_objectSpread({}, _select.default.propTypes), {}, {
  /** Label for the input */
  label: _propTypes.default.node.isRequired,
  /** Optional message which appears below the input */
  helpMessage: _propTypes.default.string,
  /** Optional error message which appears below the input */
  errorMessage: _propTypes.default.string,
  /** Component size, default is 'md' */
  visualSize: _propTypes.default.oneOf(['sm', 'md'])
});
SelectInput.displayName = 'SelectInput';
var _default = exports.default = SelectInput;